import {BaseFlowStep} from "./BaseFlowStep.jsx";
import {Router} from "../../../../stem-core/src/ui/Router.jsx";
import {INLINE_DONATION_URLS} from "../../PanelConstants.js";
import {iFrameMerchantService} from "../../../services/IframeMerchantService.js";
import {DonationStore} from "../../../../client/state/DonationStore.js";
import {Flow} from "../Flow.js";
import {Money} from "../../../../stem-core/src/localization/Money.js";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService.js";
import {Messages} from "../../../Messages.js";

export class DonationDetailsFlowStep extends BaseFlowStep {
    frequency = null;
    isCustomAmount = false;
    donationAmount = 0;
    payDonationFeeCheckboxChecked = false;

    getDefaultFields() {
        const offer = iFrameMerchantService.getDonationOffer();
        const activeDonation = iFrameUserDataService.getActiveRecurringDonation();

        if (offer && !activeDonation) {
            if (!offer.hasAmountChoice()) {
                this.donationAmount = offer.predefinedAmounts[0];
            }
            this.frequency = offer.defaultFrequency || offer.getFrequencyOptions()[0];
        }

        if (!this.donationAmount) {
            this.donationAmount = this.getDonationAmount();
        }
    }

    updateFromDonation(activeDonation) {
        this.payDonationFeeCheckboxChecked = activeDonation.isDonationFeePaid();
        this.frequency = activeDonation.frequency;
        this.donationAmount = activeDonation.computeAmount();
    }

    isValid() {
        return !!this.donationAmount && !!this.frequency;
    }

    getFrequency() {
        return this.frequency || iFrameMerchantService.getDonationOffer().defaultFrequency;
    }

    getDonationAmount() {
        const {predefinedAmounts, defaultPredefinedAmountIndex} = iFrameMerchantService.getDonationOffer();
        return this.donationAmount || predefinedAmounts[defaultPredefinedAmountIndex];
    }

    getDonationFee() {
        if (this.donationAmount) {
            return DonationStore.computeFeeFromAmount(this.donationAmount, iFrameMerchantService.merchantId);
        }
        return 0;
    }

    getTotalAmount() {
        return this.donationAmount + (Flow.donationDetails.payDonationFeeCheckboxChecked ? this.getDonationFee() : 0);
    }

    formatAmount(amount) {
        return new Money(amount, iFrameMerchantService.getDonationOffer().getCurrency()).toString();
    }

    getPayload() {
        return {
            amount: this.getTotalAmount(),
            frequency: this.getFrequency(),
            coversFees: Flow.donationDetails.payDonationFeeCheckboxChecked,
        };
    }

    getDonateComponentButtonLabel() {
        const amount = this.getTotalAmount();
        const frequency = this.getFrequency();
        if (!amount || !frequency) {
            return Messages.donate;
        }
        const formattedAmount = this.formatAmount(amount);
        const formattedFrequency = frequency.isOneTime() ? "" : "/" + frequency.name.toLowerCase();
        return Messages.donateInlineFlowButton(formattedAmount, formattedFrequency);
    }

    getEditDonationComponentButtonLabel() {
        return !this.donationAmount ? Messages.update : Messages.editDonationInlineFlowButton(
            this.formatAmount(this.getTotalAmount()),
            this.getFrequency().name.toLowerCase()
        );
    }

    showPanel() {
        Router.changeURL(INLINE_DONATION_URLS.donate);
    }
}
